import angular from "angular";
import FixedHeaders from "./FixedHeaders";
import "./style.css";

export default angular.module("fixed-headers", [])
.directive("fixedHeaders", FixedHeaders)
.name


// WEBPACK FOOTER //
// ./src/fixed-headers/index.js